/* front end application config */

/* flags to toggle between test, staging mode or live modes
* WARNING: All flags shall be false for live */
const APP_TEST_MODE = false
const APP_STAGING_MODE = true

module.exports = {
  // app configs
  API_URL: APP_TEST_MODE ? 'https://backbone.integrafms.com/api' : APP_STAGING_MODE ? 'https://backbone.integrafms.com/api' : 'https://backbone.integrafms.com/api',
  SMARTILITY_API_URL: APP_TEST_MODE ? 'https://app.integrafms.com/api' : APP_STAGING_MODE ? 'https://app.integrafms.com/api' : 'https://app.integrafms.com/api',  
  APP_DIR: '',
  SHOW_APP_DRAWER: true,
  // user details
  VENDOR_ID: '',
  VENDOR_NAME: '',
  SV_USER_ID: '',
  USER_NAME: '',
  USER_DISPLAY_NAME: '',
  EMP_ID: '',
  DASHBOARD_SCREEN_URLS: '',
  DASHBOARD_SCREEN_NAMES: '',
  PUSH_SUB: '',
  ROLE_ID: '',
  ROLE_NAME: '',
  AVATAR_URL: '',
  IS_ADMIN: false,
  IS_USER_ACTIVE: false,
  PROJ_LIST: [],
  CURRENCY: '₹',
  IS_EDITED_BY_USER: '',
  IS_VIEWED_BY_USER: ''
}
